export default __webpack_public_path__ + "img/section-header-background-yellow-b9bf7c13.png";